// extracted by mini-css-extract-plugin
module.exports = {"variables":"'~css/variables.css'","_zindex-toast":"1104","root":"toast-container_root__3wPCa"};